import styled, { css } from "styled-components";

interface TextProps {
  fontSize?: string;
  fontWeight?: number;
  lineHeight?: string;
  color?: string;
  textAlign?: string;
  fontFamily?: string;
  customStyles?: string | ReturnType<typeof css>;
}

export const Text = styled.p<TextProps>`
  font-family: ${(props) => props.fontFamily || "Manrope"};
  font-size: ${(props) => props.fontSize || "18px"};
  font-weight: ${(props) => props.fontWeight || 400};
  line-height: ${(props) => props.lineHeight};
  color: ${(props) => props.color || "#565454"};
  text-align: ${(props) => props.textAlign || "left"};
  margin: 0;
  ${(props) => props.customStyles || ""}
`;
